export default "__VITE_PUBLIC_ASSET__8b5c8113__"